(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["autumn-leaves"] && !Shopify.designMode) return;
  try {
    (() => {
    const container = document.querySelector('[data-autumn-leaves]');
    if (!container || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const namespace = 'http://www.w3.org/2000/svg';
    const shapes = [
      {
        viewBox: '0 0 64 80',
        body: 'M32 3 L38 19 L47 10 L44 27 L60 22 L53 37 L63 40 L43 52 L37 49 L35 72 L29 72 L30 50 L23 53 L3 40 L13 36 L6 21 L22 27 L18 10 L27 19 Z',
        vein: 'M32 68 L32 21 M31 47 L17 35 M33 48 L49 34 M31 38 L24 25 M34 38 L42 24'
      },
      {
        viewBox: '0 0 64 80',
        body: 'M32 4 C26 9 24 17 25 23 C18 17 12 21 15 30 C8 29 5 36 12 42 C6 47 10 55 18 54 C17 62 24 66 30 60 L29 76 L35 76 L34 59 C41 66 48 61 46 53 C54 55 59 47 51 41 C58 34 53 28 46 30 C51 22 46 16 39 22 C40 13 36 7 32 4 Z',
        vein: 'M32 72 L32 18 M31 35 L20 27 M33 43 L46 33 M31 52 L20 47 M33 55 L44 49'
      },
      {
        viewBox: '0 0 64 80',
        body: 'M31 5 L36 11 L42 10 L43 16 L49 18 L48 24 L54 28 L51 34 L57 40 L52 45 L55 52 L48 54 L46 61 L39 61 L33 72 L28 72 L23 62 L16 61 L15 54 L8 51 L12 45 L7 40 L13 34 L10 27 L17 24 L16 17 L23 16 L25 10 Z',
        vein: 'M31 68 L31 17 M30 34 L19 25 M32 41 L45 28 M30 49 L17 43 M32 53 L46 45'
      },
      {
        viewBox: '0 0 64 80',
        body: 'M32 4 C42 8 52 18 54 31 C57 47 48 61 34 72 L31 77 L28 72 C15 62 7 49 10 34 C12 19 21 8 32 4 Z',
        vein: 'M31 71 C32 55 32 38 32 16 M31 33 L20 23 M32 42 L45 29 M31 51 L18 42 M32 58 L44 48'
      }
    ];
    const palettes = [
      ['#f2bf45', '#d27628', '#7d351e'],
      ['#e47c35', '#b94729', '#6b241e'],
      ['#d95731', '#9a3027', '#541e20'],
      ['#e3a13a', '#ad6727', '#65391d'],
      ['#c96a32', '#8b3c25', '#4c211c'],
      ['#efc958', '#c38b2b', '#76501d']
    ];
    const leafCount = window.matchMedia('(max-width: 749px)').matches ? 8 : 13;

    for (let index = 0; index < leafCount; index += 1) {
      const fall = document.createElement('span');
      const leaf = document.createElementNS(namespace, 'svg');
      const shape = shapes[index % shapes.length];
      const colors = palettes[index % palettes.length];
      const gradientId = 'autumn-leaf-' + index;
      const direction = index % 2 === 0 ? 1 : -1;
      const drift = direction * (5 + Math.random() * 10);

      fall.className = 'autumn-leaves__fall';
      leaf.setAttribute('class', 'autumn-leaves__leaf');
      leaf.setAttribute('viewBox', shape.viewBox);
      leaf.setAttribute('focusable', 'false');
      leaf.setAttribute('aria-hidden', 'true');
      leaf.innerHTML =
        '<defs><linearGradient id="' + gradientId + '" x1="16%" y1="8%" x2="84%" y2="92%">' +
        '<stop offset="0%" stop-color="' + colors[0] + '"/>' +
        '<stop offset="54%" stop-color="' + colors[1] + '"/>' +
        '<stop offset="100%" stop-color="' + colors[2] + '"/>' +
        '</linearGradient></defs>' +
        '<path d="' + shape.body + '" fill="url(#' + gradientId + ')"/>' +
        '<ellipse class="autumn-leaves__spot" cx="39" cy="34" rx="7" ry="4"/>' +
        '<ellipse class="autumn-leaves__spot" cx="24" cy="48" rx="5" ry="3"/>' +
        '<path class="autumn-leaves__vein" d="' + shape.vein + '"/>';

      fall.style.setProperty('--leaf-left', String(Math.random() * 98) + '%');
      fall.style.setProperty('--leaf-size', String(17 + Math.random() * 12) + 'px');
      fall.style.setProperty('--fall-duration', String(12 + Math.random() * 8) + 's');
      fall.style.setProperty('--fall-delay', String(-Math.random() * 20) + 's');
      fall.style.setProperty('--flutter-duration', String(1.7 + Math.random() * 1.8) + 's');
      fall.style.setProperty('--leaf-drift-mid', String(drift * -0.45) + 'vw');
      fall.style.setProperty('--leaf-drift-end', String(drift) + 'vw');
      fall.style.setProperty('--leaf-opacity', String(0.6 + Math.random() * 0.24));
      fall.style.setProperty('--leaf-turn-start', String(-26 + Math.random() * 18) + 'deg');
      fall.style.setProperty('--leaf-turn-end', String(16 + Math.random() * 24) + 'deg');
      fall.style.setProperty('--leaf-vein', colors[2]);
      fall.style.setProperty('--leaf-dark', colors[2]);
      fall.appendChild(leaf);
      container.appendChild(fall);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
